


































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import * as _ from "lodash";
import { GetZlkzZhenciList, DangeZhiyi, Shenhetongguo } from "@/request/sjzx";
import {
  InstitutionList,
  CreatorList,
  GetTemplatesOfGroup,
  GetTopicsOfTemplate,
  PatientDetail,
} from "@/request/zhuanbingshujuku";
import { GetUserInfo, ZuzhijiagouList } from "@/request/yonghuquanxian";
import Pagination from "@/components/paginaiton.vue";
import Copy from "@/components/copy.vue";
import ZhiyiDialog from "../../components/zhiyiiDialog.vue";
import ZhiyijiluDialog from "../../components/zhiyijiluDialog.vue";
@Component({
  components: {
    Copy,
    Pagination,
    ZhiyiDialog,
    ZhiyijiluDialog,
  },
})
export default class ZlkzPatientList extends Vue {
  // 当前用户信息
  private user: any = {};
  private filters: any = {
    institution_id: "",
    user_ids: [],
    status: "",
    search: "",
    currentPage: 1,
    totalPage: 0,
    totalCount: 0,
    pageSize: 10,
    cSortField: "创建时间",
    cSortValue: "0",
  };
  private ifLoading: boolean = false;
  // 搜索条件
  private institutions: any[] = [];
  private creators: any[] = [];
  private saveModel: "add" | "delete" = "add";
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 列表
  private patients: any[] = [];
  // 质疑
  private ifShowZhiyi: boolean = false;
  private zhiyi: any = {};
  private tempZhenci: any = {};
  // 查看质疑记录
  private ifShowZhiyijilu: boolean = false;
  private get center() {
    const localCenter = localStorage.getItem("center");
    if (!localCenter) {
      return {};
    } else {
      return JSON.parse(localCenter);
    }
  }

  @Watch("center", { immediate: true, deep: true })
  private centerChange(e) {
    const localFilters = localStorage.getItem("zlkzFilters");
    if (!localFilters) {
      this.$set(this, "filters", {
        institution_id: "",
        范围: [],
        user_ids: [],
        status: "",
        search: "",
        currentPage: 1,
        totalPage: 0,
        totalCount: 0,
        pageSize: 10,
        cSortField: "创建时间",
        cSortValue: "0",
      });
    } else {
      this.$set(this, "filters", JSON.parse(localFilters));
    }
    if (e.project_id) {
      this.getCurrentUserInfo();
      this.fetchPatients().then(() => {
        this.getInstitutions();
      });
    }
  }
  private setFilters() {
    localStorage.setItem("zlkzFilters", JSON.stringify(this.filters));
  }
  /**
   * @description 获取当前用户信息
   */
  private getCurrentUserInfo() {
    if (!this.center.project_id) {
      return;
    }
    const params: any = {
      params: {
        project_id: this.center.project_id,
      },
    };
    GetUserInfo(this, params).then((data: any) => {
      this.$set(this, "user", data);
    });
  }
  /**
   * @description 判断当前用户在当前机构下能否显示某个功能
   */
  private canThisRoleUse(tool) {
    let canUse = false;
    try {
      switch (tool) {
        case "查看质疑记录":
          if (
            this.$store.state.roleControl["数据录入"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            canUse = true;
          }
          break;
        case "质疑":
          if (
            this.$store.state.roleControl["质疑"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            canUse = true;
          }
          break;
        case "审核通过":
          if (
            this.$store.state.roleControl["审核通过"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            canUse = true;
          }
          break;
      }
    } catch (e) {
      console.log(e);
    }
    return canUse;
  }
  /**
   * @description 搜索可选的机构
   */
  private getInstitutions() {
    const params: any = {
      params: {
        project_id: this.center.project_id,
      },
    };
    ZuzhijiagouList(this, params).then((data: any) => {
      this.institutions = _.uniqBy(data, "institution_id");
    });
  }
  /**
   * @description 选择机构改变
   */
  private institutionChange() {
    this.filters.user_ids = [];
    this.getCreatorsList();
    this.search();
  }
  /**
   * @description 获得可选的创建者列表
   */
  private getCreatorsList() {
    const params: any = {
      project_id: this.center.project_id,
      institution_id: [this.filters.institution_id], // 暂时为空选择全部
    };
    CreatorList(this, params).then((data: any) => {
      this.creators = data;
    });
  }
  /**
   * @description 创建人改变
   */
  private creatorsChange() {
    this.search();
  }
  /**
   * @description 状态改变
   */
  private statusChange() {
    this.search();
  }
  /**
   * @description 获取病人列表
   */
  private fetchPatients() {
    return new Promise((resolve, reject) => {
      this.ifLoading = true;
      const params: any = {};
      // 处理基本搜索条件
      params["institution_ids"] =
        this.filters.institution_id === "" ? [] : [this.filters.institution_id];
      params["project_id"] = this.center.project_id;
      params["user_ids"] = this.filters.user_ids;
      params["status"] = this.filters.status;
      params["order_field"] = this.filters.cSortField;
      params["order_value"] = this.filters.cSortValue;
      params["current_page"] = this.filters.currentPage;
      params["page_count"] = this.filters.pageSize;
      params["search"] = this.filters.search;

      GetZlkzZhenciList(this, params)
        .then((data: any) => {
          this.patients = data.zhencis;
          this.filters.totalPage = data.total_page;
          this.filters.totalCount = data.total_count;
          if (this.saveModel === "add") {
            this.checkAllMessages(false);
            this.autoCheckSelectedMessages(true);
          } else {
            this.checkAllMessages(true);
            this.autoCheckSelectedMessages(false);
          }
          const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
          this.checkAll = checkedCount === this.patients.length;
          this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.patients.length;
          resolve();
        })
        .catch(() => {
          reject();
        })
        .finally(() => {
          this.setFilters();
          this.ifLoading = false;
        });
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.currentPage = 1;
    this.saveModel = "delete";
    this.fetchPatients();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.filters.currentPage = val;
    this.fetchPatients();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.filters.cSortField = ev["prop"];
    this.filters.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.fetchPatients();
  }
  // 勾选
  /**
   * @description 给所有message勾选上
   */
  private checkAllMessages(isChecked: boolean) {
    this.patients.forEach((message: any, index: number) => {
      this.$set(this.patients[index], "isChecked", isChecked);
    });
    this.isIndeterminate = false;
    this.checkAll = isChecked ? true : false;
  }
  /**
   * @description 增加一个数据到已选列表
   */
  private addOneMessageToSelectedMessages(message: any) {
    this.selectedMessages.push(message);
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 从已选列表中删除一条数据
   */
  private deleteOneMessageFromSelectedMessages(message: any) {
    const index = this.selectedMessages.findIndex(
      (selectedMessage: any) =>
        selectedMessage.patient_id === message.patient_id
    );
    if (index !== -1) {
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 增加当前页面所有的消息进入已选列表
   */
  private addAllMessagesToSelectedMessages() {
    this.patients.forEach((message: any) => {
      this.selectedMessages.push(message);
    });
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 将当前页面的所有数据，从已选列表中删除
   */
  private deleteAllMessagesFromSelectedMessages() {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        this.selectedMessages.splice(targetIndex, 1);
      }
    });
  }
  /**
   * @description 统计当前页面有多少数据被选中
   */
  private countHowMuchCurrentPageMessagesSelected() {
    let checkedCount = 0;
    this.patients.forEach((message: any) => {
      if (message.isChecked) {
        checkedCount++;
      }
    });
    return checkedCount;
  }
  /**
   * @description 翻页后自动勾选上已经选择的数据
   */
  private autoCheckSelectedMessages(isChecked: boolean) {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        message.isChecked = isChecked;
      }
    });
  }
  /**
   * @description 处理点击全选
   */
  private handleCheckAllChange(val) {
    if (val) {
      this.checkAllMessages(true);
      if (this.saveModel === "add") {
        this.addAllMessagesToSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.deleteAllMessagesFromSelectedMessages();
      }
    } else {
      this.checkAllMessages(false);
      if (this.saveModel === "add") {
        this.deleteAllMessagesFromSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.addAllMessagesToSelectedMessages();
      }
    }
  }
  /**
   * @description 处理单个勾选
   */
  private handleCheckedMessageChange(val, item) {
    if (val) {
      if (this.saveModel === "add") {
        this.addOneMessageToSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.deleteOneMessageFromSelectedMessages(item);
      }
    } else {
      if (this.saveModel === "add") {
        this.deleteOneMessageFromSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.addOneMessageToSelectedMessages(item);
      }
    }
    const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
    this.checkAll = checkedCount === this.patients.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.patients.length;
  }
  /**
   * @description 跳转某个病人的某个诊次
   */
  private jumpZhenci(zhenci) {
    console.log(zhenci);
    const zindex = zhenci["zhenci"] - 1;
    const patientParams: any = {
      params: {
        project_id: this.center.project_id,
        group_id: this.center.group_id,
        patient_id: zhenci.patient_id,
      },
    };
    PatientDetail(this, patientParams).then((patient: any) => {
      localStorage.setItem("patient", JSON.stringify(patient));
      this.$router.push({
        path: "/main/zbsjk/zbsjk-detail",
        query: {
          zIndex: zindex.toString(),
        },
      });
    });
  }
  /**
   * @description 查看质疑记录
   */
  private checkZhiyiList(zhenci) {
    this.tempZhenci = _.cloneDeep(zhenci);
    this.ifShowZhiyijilu = true;
  }
  /**
   * @description 打开质疑弹窗
   */
  private openZhiyi(zhenci) {
    console.log(this.user);
    console.log(zhenci);
    if (zhenci.status === "已通过" && this.user.role["名称"] === "质量审核员") {
      if (zhenci.pass_user_id !== this.user.user_id) {
        this.$message.warning(
          zhenci.role +
            "(" +
            zhenci.pass_account_name +
            ")已审核通过，无法质疑！"
        );
        return;
      }
    } else if (
      zhenci.status === "已通过" &&
      this.user.role["名称"] === "监查员"
    ) {
      if (
        zhenci.role === "监查员" &&
        zhenci.pass_user_id !== this.user.user_id
      ) {
        this.$message.warning(
          zhenci.role +
            "(" +
            zhenci.pass_account_name +
            ")已审核通过，无法质疑！"
        );
        return;
      }
    }

    this.zhiyi = {};
    this.tempZhenci = _.cloneDeep(zhenci);
    const params: any = {
      params: {
        zhenci_id: zhenci.zhenci_id,
      },
    };
    DangeZhiyi(this, params).then((data: any) => {
      if (!data.logs) {
        data.logs = [];
      }
      this.zhiyi = data;
      this.ifShowZhiyi = true;
    });
  }

  /**
   * @description 确认审核通过
   */
  private confirmShenhetongguo(zhenci) {
    this.$confirm("请认真查看后才点击审核通过", {
      title: "审核通过",
      confirmButtonText: "已查阅，确认审核通过",
    })
      .then(() => {
        const params: any = {
          project_id: this.center.project_id,
          patient_id: zhenci.patient_id,
          zhenci_id: zhenci.zhenci_id,
          action: "通过",
        };
        Shenhetongguo(this, params).then((data: any) => {
          this.$message.success("通过成功！");
          this.fetchPatients();
        });
      })
      .catch(() => {
        console.log("取消");
      });
  }

  /**
   * @description 初始化
   */
  private mounted() {
    this.getCreatorsList();
  }
}
